import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { changeHighlight } from "ducks/ui/actions";

const propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
  changeHighlight: PropTypes.func.isRequired,
  highlighted: PropTypes.bool.isRequired,
  children: PropTypes.any.isRequired,
};

class OnMountHighlighter extends React.Component {
  componentDidMount() {
    const { id, name, changeHighlight, highlighted } = this.props;
    if (id === highlighted) return;
    changeHighlight({ name, id });
  }
  render() {
    return this.props.children;
  }
}

const mapState = (state, props) => ({
  highlighted: state.ui.highlights[props.name] === props.id,
});

OnMountHighlighter.propTypes = propTypes;
export default connect(mapState, { changeHighlight })(OnMountHighlighter);



// WEBPACK FOOTER //
// ./src/components/ui/OnMountHighlighter.jsx